import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewGuestListPage from "../../components/GuestList/ViewGuestListPage";

const ViewGuestList = () => {
  return (
    <MasterLayout>
      <Breadcrumb
        id="title"
        title2="Guest List"
        link2="/guestList"
        title="View Guest List"
      />
      <ViewGuestListPage />
    </MasterLayout>
  );
};

export default ViewGuestList;
